import { defineStore } from "pinia";
import { useCurrentUser, useCurrentUserScope } from "../api/current-user";
import { useAuthStore } from "./auth";
import { useQueryManager } from "./query-manager";

export const useAppStore = defineStore("app", () => {
	const isReady = ref(false);
	const isLoading = ref(false);

	const router = useRouter();

	const currentUserQuery = useCurrentUser();
	const currentScopeQuery = useCurrentUserScope();

	async function fetchEssentialData() {
		// User must be loaded first, since the scope loading depend on the user data.
		await currentUserQuery.refresh();
		await currentScopeQuery.refresh();
	}

	const queryManager = useQueryManager();

	const authStore = useAuthStore();

	function redirectToLogin() {
		return router.push({ name: "auth-login" });
	}

	async function init() {
		isReady.value = false;
		try {
			if (!authStore.isAuth) {
				return;
			}

			queryManager.activate();
			isLoading.value = true;

			const timeout = new Promise((_, rej) => setTimeout(rej, 5_000));
			try {
				await Promise.race([fetchEssentialData(), timeout]);
			} catch {
				return redirectToLogin();
			}
		} finally {
			isReady.value = true;
		}

		// Give time to the app to fully render
		await new Promise((res) => setTimeout(res, 500));
		isLoading.value = false;
	}

	async function waitReady() {
		return until(isReady).toBeTruthy();
	}

	return {
		isReady,
		isLoading,
		init,
		waitReady,
	};
});
